import React from 'react';

export default function LoadingState() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: '#f5f5f0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      WebkitFontSmoothing: 'antialiased',
    }}>
      <style>{`
        @keyframes dash-scroll {
          to { stroke-dashoffset: -600; }
        }
        @keyframes load-fade-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes dot-pulse {
          0%, 100% { opacity: 0.25; transform: scale(0.85); }
          50%       { opacity: 1;    transform: scale(1); }
        }
        .load-path-dash {
          stroke-dasharray: 5 5;
          animation: dash-scroll 18s linear infinite;
        }
        .load-text-block {
          animation: load-fade-in 0.55s ease 0.15s both;
        }
        .load-dot { display: inline-block; width: 5px; height: 5px; border-radius: 50%; background: #1d4ed8; }
        .load-dot-1 { animation: dot-pulse 1.3s ease-in-out infinite 0.0s; }
        .load-dot-2 { animation: dot-pulse 1.3s ease-in-out infinite 0.2s; }
        .load-dot-3 { animation: dot-pulse 1.3s ease-in-out infinite 0.4s; }
      `}</style>

      <svg
        width="340"
        height="190"
        viewBox="0 0 340 190"
        style={{ overflow: 'visible' }}
        aria-hidden="true"
      >
        <defs>
          <path id="lp-route" d="M 40 155 C 90 155 170 18 300 58" />
        </defs>

        {/* Soft glow */}
        <use href="#lp-route" fill="none" stroke="#1d4ed8" strokeWidth="10" strokeLinecap="round" opacity="0.05" />

        {/* Dashed route line */}
        <use className="load-path-dash" href="#lp-route" fill="none" stroke="#1d4ed8" strokeWidth="1.5" strokeLinecap="round" opacity="0.22" />

        {/* SIN dot + pulse */}
        <circle cx="40" cy="155" r="12" fill="none" stroke="#1d4ed8" strokeWidth="1" opacity="0">
          <animate attributeName="r"       values="7;16;7"      dur="2.4s" repeatCount="indefinite" begin="0s" />
          <animate attributeName="opacity" values="0.18;0;0.18" dur="2.4s" repeatCount="indefinite" begin="0s" />
        </circle>
        <circle cx="40" cy="155" r="5" fill="white" stroke="#1d4ed8" strokeWidth="1.5" />
        <text x="40" y="174" textAnchor="middle" fontSize="10" fontWeight="500" fill="#9b9891" fontFamily="DM Sans, sans-serif" letterSpacing="0.04em">SIN</text>

        {/* LHR dot + pulse */}
        <circle cx="300" cy="58" r="12" fill="none" stroke="#1d4ed8" strokeWidth="1" opacity="0">
          <animate attributeName="r"       values="7;16;7"      dur="2.4s" repeatCount="indefinite" begin="1.2s" />
          <animate attributeName="opacity" values="0.18;0;0.18" dur="2.4s" repeatCount="indefinite" begin="1.2s" />
        </circle>
        <circle cx="300" cy="58" r="5" fill="white" stroke="#1d4ed8" strokeWidth="1.5" />
        <text x="300" y="77" textAnchor="middle" fontSize="10" fontWeight="500" fill="#9b9891" fontFamily="DM Sans, sans-serif" letterSpacing="0.04em">LHR</text>

        {/* Plane — points along +x so rotate="auto" faces direction of travel */}
        <g opacity="0.95">
          <path d="M8,0 L0,-2.8 L-7,-2.2 L-7,2.2 L0,2.8 Z" fill="#1d4ed8" />
          <path d="M1.5,-2.8 L-1,-10 L-4.5,-9.5 L-2.8,-2.8 Z" fill="#1d4ed8" />
          <path d="M1.5,2.8 L-1,10 L-4.5,9.5 L-2.8,2.8 Z" fill="#1d4ed8" />
          <path d="M-7,-2.2 L-9.5,-5 L-10.5,-4 L-8,-2.2 Z" fill="#1d4ed8" />
          <path d="M-7,2.2 L-9.5,5 L-10.5,4 L-8,2.2 Z" fill="#1d4ed8" />
          <animateMotion
            dur="3.8s"
            repeatCount="indefinite"
            rotate="auto"
            calcMode="spline"
            keyPoints="0;1"
            keyTimes="0;1"
            keySplines="0.42 0 0.58 1"
          >
            <mpath href="#lp-route" />
          </animateMotion>
        </g>
      </svg>

      <div className="load-text-block" style={{ textAlign: 'center', marginTop: '4px' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#111111', letterSpacing: '-0.01em', marginBottom: '5px' }}>
          Loading flight data
        </div>
        <div style={{ fontSize: '12px', color: '#9b9891', fontWeight: 400, marginBottom: '16px' }}>
          Singapore Airlines Route Network
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
          <span className="load-dot load-dot-1" />
          <span className="load-dot load-dot-2" />
          <span className="load-dot load-dot-3" />
        </div>
      </div>
    </div>
  );
}
